// // src/pages/admin/coupons/AddCoupon.jsx
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { useNavigate, useParams } from "react-router-dom";

// export default function AddCoupon() {
//   const { id } = useParams(); // couponId from route (optional for edit)
//   const navigate = useNavigate();

//   const [events, setEvents] = useState([]);
//   const [isEdit, setIsEdit] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUploading, setIsUploading] = useState(false);

//   // Helpers: ISO <-> datetime-local value
//   const toLocalDTValue = (iso) => {
//     if (!iso) return "";
//     const d = new Date(iso);
//     const pad = (n) => String(n).padStart(2, "0");
//     const yyyy = d.getFullYear();
//     const mm = pad(d.getMonth() + 1);
//     const dd = pad(d.getDate());
//     const hh = pad(d.getHours());
//     const mi = pad(d.getMinutes());
//     return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
//   };
//   const toISOFromLocal = (localVal) => {
//     if (!localVal) return null;
//     const d = new Date(localVal);
//     return d.toISOString();
//   };

//   const [formData, setFormData] = useState({
//     code: "",
//     description: "",
//     discountType: "percentage", // "percentage" | "fixed" | "bogo"
//     value: 0,
//     validFrom: "",
//     validTo: "",
//     imageUrl: "",
//     usageLimit: 0,
//     minPurchaseAmount: 0,
//     applicableEvents: [], // array of event IDs
//     isActive: false,
//     perUserLimit: 0,

//     // NEW
//     maxDiscountAmount: 0,               // 0 = no cap
//     termsAndConditions: [],             // array of strings

//     // BOGO specific
//     buy: 1,
//     get: 1,
//     applicableCategory: "",
//   });

//   // Fetch events list for the multi-select
//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.events.getEvent, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (Array.isArray(res?.events)) setEvents(res.events);
//       } catch (err) {
//         console.error("getAllEvents error:", err);
//       }
//     };
//     fetchEvents();
//   }, []);

//   // Fetch coupon data if edit mode
//   useEffect(() => {
//     if (!id) return;
//     setIsEdit(true);
//     const fetchCoupon = async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.coupon.getSingle}/${id}`, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });

//         if (res?.discount) {
//           const d = res.discount;

//           const eventIds = Array.isArray(d.applicableEvents)
//             ? d.applicableEvents
//                 .map((ev) => (typeof ev === "string" ? ev : ev?._id))
//                 .filter(Boolean)
//             : [];

//           setFormData({
//             code: d.code || "",
//             description: d.description || "",
//             discountType: d.discountType || "percentage",
//             value: Number(d.value ?? 0),
//             validFrom: toLocalDTValue(d.validFrom),
//             validTo: toLocalDTValue(d.validTo),
//             imageUrl: d.imageUrl || "",
//             usageLimit: Number(d.usageLimit ?? 0),
//             minPurchaseAmount: Number(d.minPurchaseAmount ?? 0),
//             perUserLimit: Number(d.perUserLimit ?? 0),
//             applicableEvents: eventIds,
//             isActive: Boolean(d.isActive),

//             // NEW
//             maxDiscountAmount: Number(d.maxDiscountAmount ?? 0),
//             termsAndConditions: Array.isArray(d.termsAndConditions)
//               ? d.termsAndConditions
//               : d.termsAndConditions
//               ? [String(d.termsAndConditions)]
//               : [],

//             // BOGO (if present on server)
//             buy: Number(d.buy ?? 1),
//             get: Number(d.get ?? 1),
//             applicableCategory: d.applicableCategory || "",
//           });
//         }
//       } catch (err) {
//         console.error("Error fetching coupon:", err);
//       }
//     };
//     fetchCoupon();
//   }, [id]);

//   // Generic change handler for inputs
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     // number fields
//     const numberFields = new Set([
//       "value",
//       "usageLimit",
//       "minPurchaseAmount",
//       "perUserLimit",
//       "buy",
//       "get",
//       "maxDiscountAmount", // NEW
//     ]);
//     if (numberFields.has(name)) {
//       const num = value === "" ? "" : Number(value);
//       setFormData((p) => ({ ...p, [name]: num }));
//       return;
//     }

//     if (type === "checkbox") {
//       setFormData((p) => ({ ...p, [name]: checked }));
//       return;
//     }

//     setFormData((p) => ({ ...p, [name]: value }));
//   };

//   // --- Terms & Conditions helpers (array) ---
//   const addTerm = () =>
//     setFormData((p) => ({
//       ...p,
//       termsAndConditions: [...(p.termsAndConditions || []), ""],
//     }));

//   const updateTerm = (idx, val) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr[idx] = val;
//       return { ...p, termsAndConditions: arr };
//     });

//   const removeTerm = (idx) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr.splice(idx, 1);
//       return { ...p, termsAndConditions: arr };
//     });

//   // Image upload
//   const handleImageUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const formDataObj = new FormData();
//     formDataObj.append("file", file);

//     try {
//       setIsUploading(true);
//       const res = await post(API.events.fileUploader, formDataObj, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (res?.url) {
//         setFormData((prev) => ({ ...prev, imageUrl: res.url }));
//       }
//     } catch (error) {
//       console.error("Image upload failed:", error);
//       alert("Image upload failed ❌");
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   // Submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//       // Build payload to match your JSON exactly
//       const base = {
//         code: formData.code.trim(),
//         description: formData.description.trim(),
//         discountType: formData.discountType,
//         validFrom: toISOFromLocal(formData.validFrom),
//         validTo: toISOFromLocal(formData.validTo),
//         imageUrl: formData.imageUrl || "",
//         usageLimit: Number(formData.usageLimit || 0),
//         minPurchaseAmount: Number(formData.minPurchaseAmount || 0),
//         applicableEvents: Array.isArray(formData.applicableEvents)
//           ? formData.applicableEvents
//           : [],
//         isActive: Boolean(formData.isActive),
//         perUserLimit: Number(formData.perUserLimit || 0),

//         // NEW
//         maxDiscountAmount: Number(formData.maxDiscountAmount || 0), // 0 = no cap
//         termsAndConditions: (Array.isArray(formData.termsAndConditions)
//           ? formData.termsAndConditions
//           : []
//         )
//           .map((s) => String(s).trim())
//           .filter(Boolean),
//       };

//       let payload = { ...base };

//       if (formData.discountType === "bogo") {
//         payload = {
//           ...base,
//           buy: Number(formData.buy || 0),
//           get: Number(formData.get || 0),
//           applicableCategory: (formData.applicableCategory || "").trim(),
//         };
//       } else {
//         payload = {
//           ...base,
//           value: Number(formData.value || 0),
//         };
//       }

//       // basic validation
//       if (!payload.code) {
//         alert("Please enter a coupon code.");
//         setIsLoading(false);
//         return;
//       }
//       if (!payload.discountType) {
//         alert("Please select a discount type.");
//         setIsLoading(false);
//         return;
//       }
//       if (!base.validFrom || !base.validTo) {
//         alert("Please choose Valid From and Valid To.");
//         setIsLoading(false);
//         return;
//       }

//       if (formData.discountType === "percentage") {
//         if (payload.value < 0 || payload.value > 100) {
//           alert("Percentage value must be between 0 and 100.");
//           setIsLoading(false);
//           return;
//         }
//       } else if (formData.discountType === "bogo") {
//         if (payload.buy <= 0 || payload.get <= 0) {
//           alert("For BOGO, Buy and Get must be greater than 0.");
//           setIsLoading(false);
//           return;
//         }
//         if (!payload.applicableCategory) {
//           alert("For BOGO, please enter Applicable Category.");
//           setIsLoading(false);
//           return;
//         }
//       }

//       if (isEdit) {
//         await put(`${API.coupon.updateDiscount}/${id}`, payload, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         alert("✅ Coupon Updated Successfully");
//       } else {
//         await post(API.coupon.creareDiscount, payload, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         alert("✅ Coupon Added Successfully");
//       }

//       navigate("/admin/coupon");
//     } catch (err) {
//       console.error("Error saving coupon:", err);
//       alert("❌ Failed to save coupon");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Dynamic constraints for value input
//   const valueMax = useMemo(
//     () => (formData.discountType === "percentage" ? 100 : undefined),
//     [formData.discountType]
//   );

//   const isBOGO = formData.discountType === "bogo";

//   return (
//     <div className="p-6 max-w-3xl mx-auto">
//       <h2 className="text-2xl font-semibold mb-6">
//         {isEdit ? "Edit Coupon" : "Add New Coupon"}
//       </h2>

//       <form
//         onSubmit={handleSubmit}
//         className="bg-white shadow-lg rounded-2xl p-6 space-y-5"
//       >
//         {/* Code */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Code
//           </label>
//           <input
//             type="text"
//             name="code"
//             value={formData.code}
//             onChange={handleChange}
//             required
//             placeholder="e.g. FESTIVE50"
//             className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>

//         {/* Description */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Description
//           </label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             rows={3}
//             placeholder="Flat 50% off on festive season events"
//             className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//           />
//         </div>

//         {/* Discount Type + Value */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Discount Type
//             </label>
//             <select
//               name="discountType"
//               value={formData.discountType}
//               onChange={handleChange}
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="percentage">Percentage</option>
//               <option value="fixed">Fixed Amount</option>
//               <option value="bogo">Bogo</option>
//             </select>
//           </div>

//           {/* Value (hidden for BOGO) */}
//           {!isBOGO && (
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 {formData.discountType === "percentage"
//                   ? "Value (%)"
//                   : "Value (₹)"}
//               </label>
//               <input
//                 type="number"
//                 name="value"
//                 value={formData.value}
//                 onChange={handleChange}
//                 min={0}
//                 max={valueMax}
//                 step={formData.discountType === "percentage" ? "0.01" : "1"}
//                 required
//                 placeholder={
//                   formData.discountType === "percentage" ? "e.g. 50" : "e.g. 200"
//                 }
//                 className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 {formData.discountType === "percentage"
//                   ? "0–100 allowed"
//                   : "Fixed discount in ₹"}
//               </p>
//             </div>
//           )}
//         </div>

//         {/* BOGO fields */}
//         {isBOGO && (
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Buy (Qty)
//               </label>
//               <input
//                 type="number"
//                 name="buy"
//                 value={formData.buy}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Get (Qty)
//               </label>
//               <input
//                 type="number"
//                 name="get"
//                 value={formData.get}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Applicable Category
//               </label>
//               <input
//                 type="text"
//                 name="applicableCategory"
//                 value={formData.applicableCategory}
//                 onChange={handleChange}
//                 placeholder="e.g. VVIP / Gold / GA"
//                 className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Category name where BOGO applies.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Validity */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Valid From
//             </label>
//             <input
//               type="datetime-local"
//               name="validFrom"
//               value={formData.validFrom}
//               onChange={handleChange}
//               required
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Valid To
//             </label>
//             <input
//               type="datetime-local"
//               name="validTo"
//               value={formData.validTo}
//               onChange={handleChange}
//               required
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//         </div>

//         {/* Per User, Image */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Per User Limits
//             </label>
//             <input
//               type="number"
//               name="perUserLimit"
//               value={formData.perUserLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               required
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Upload Image
//             </label>
//             <input type="file" accept="image/*" onChange={handleImageUpload} className="w-full" />
//             {isUploading && <p className="text-blue-500 text-sm mt-1">Uploading image...</p>}
//             {formData.imageUrl && (
//               <img
//                 src={formData.imageUrl}
//                 alt="Preview"
//                 className="mt-3 w-48 h-28 object-cover rounded-xl border"
//               />
//             )}
//           </div>
//         </div>

//         {/* Limits / Minimums (+ NEW Max Discount Cap) */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Usage Limit
//             </label>
//             <input
//               type="number"
//               name="usageLimit"
//               value={formData.usageLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               placeholder="e.g. 100"
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Min Purchase Amount (₹)
//             </label>
//             <input
//               type="number"
//               name="minPurchaseAmount"
//               value={formData.minPurchaseAmount}
//               onChange={handleChange}
//               min={0}
//               step="0.01"
//               placeholder="e.g. 500"
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* NEW: Max Discount Amount */}
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Maximum Discount Amount (₹)
//             </label>
//             <input
//               type="number"
//               name="maxDiscountAmount"
//               value={formData.maxDiscountAmount}
//               onChange={handleChange}
//               min={0}
//               step="0.01"
//               placeholder="0 = No cap"
//               className="w-full border rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <p className="text-xs text-gray-500 mt-1">
//               Put 0 if you don’t want to cap the discount.
//             </p>
//           </div>
//         </div>

//         {/* NEW: Terms & Conditions (Array) */}
//         <div>
//           <div className="flex items-center justify-between">
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Terms &amp; Conditions
//             </label>
//             <button
//               type="button"
//               onClick={addTerm}
//               className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-gray-900 hover:bg-amber-300"
//             >
//               + Add line
//             </button>
//           </div>

//           {formData.termsAndConditions?.length === 0 && (
//             <p className="text-xs text-gray-500">
//               Add one or more T&amp;C lines. Each line will be shown separately to users.
//             </p>
//           )}

//           <div className="mt-2 space-y-2">
//             {formData.termsAndConditions?.map((t, idx) => (
//               <div key={idx} className="flex items-start gap-2">
//                 <div className="pt-2 text-gray-400 text-sm">{idx + 1}.</div>
//                 <textarea
//                   value={t}
//                   onChange={(e) => updateTerm(idx, e.target.value)}
//                   rows={2}
//                   placeholder="Type a condition (one per line item)"
//                   className="flex-1 border rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => removeTerm(idx)}
//                   className="mt-2 rounded-full border px-2 py-1 text-sm hover:bg-gray-50"
//                   aria-label="Remove"
//                   title="Remove line"
//                 >
//                   ✕
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Applicable Events */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Applicable Events
//           </label>
//           <MultiSelect
//             options={events.map((ev) => ({ label: ev.name, value: ev._id }))}
//             values={formData.applicableEvents}
//             onChange={(vals) =>
//               setFormData((p) => ({ ...p, applicableEvents: vals }))
//             }
//             placeholder="Select events"
//             disabled={events.length === 0}
//           />
//         </div>

//         {/* Active Status */}
//         <div className="flex items-center gap-2">
//           <input
//             type="checkbox"
//             name="isActive"
//             checked={formData.isActive}
//             onChange={handleChange}
//             className="w-4 h-4"
//           />
//           <label className="text-sm text-gray-700">Active</label>
//         </div>

//         {/* Submit Button */}
//         <div className="flex justify-end">
//           <button
//             type="submit"
//             disabled={isLoading}
//             className="px-6 py-2 inline-flex items-center mt-6 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 text-base font-semibold text-gray-900 hover:from-yellow-500 hover:to-yellow-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             {isLoading ? (isEdit ? "Updating..." : "Saving...") : isEdit ? "Update Coupon" : "Save Coupon"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// /* ---------- Inline, library-free MultiSelect with search & chips ---------- */
// function MultiSelect({
//   options = [],
//   values = [],
//   onChange,
//   placeholder = "Select...",
//   disabled = false,
// }) {
//   const [open, setOpen] = useState(false);
//   const [query, setQuery] = useState("");
//   const boxRef = useRef(null);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!boxRef.current?.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return options;
//     return options.filter((o) => o.label.toLowerCase().includes(q));
//   }, [options, query]);

//   const toggle = (val) => {
//     if (!onChange) return;
//     if (values.includes(val)) {
//       onChange(values.filter((v) => v !== val));
//     } else {
//       onChange([...values, val]);
//     }
//   };

//   const remove = (val) => onChange && onChange(values.filter((v) => v !== val));

//   const labelByVal = useMemo(() => {
//     const m = new Map();
//     options.forEach((o) => m.set(o.value, o.label));
//     return m;
//   }, [options]);

//   const buttonText =
//     values.length === 0
//       ? placeholder
//       : values.length === 1
//       ? labelByVal.get(values[0]) || "1 selected"
//       : `${values.length} selected`;

//   return (
//     <div className="relative" ref={boxRef}>
//       <button
//         type="button"
//         disabled={disabled}
//         onClick={() => setOpen((o) => !o)}
//         className={`w-full border rounded-xl px-3 py-2 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 flex items-center justify-between ${
//           disabled ? "bg-gray-50 cursor-not-allowed text-gray-400" : ""
//         }`}
//       >
//         <span className="truncate">{buttonText}</span>
//         <svg width="16" height="16" viewBox="0 0 24 24">
//           <polyline
//             points="6 9 12 15 18 9"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </svg>
//       </button>

//       {open && !disabled && (
//         <div className="absolute z-50 mt-2 w-full rounded-xl border bg-white shadow-lg">
//           {/* search */}
//           <div className="p-2 border-b">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search events…"
//               className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* options */}
//           <div className="max-h-64 overflow-auto py-1">
//             {filtered.length === 0 ? (
//               <div className="px-3 py-2 text-sm text-gray-500">No results</div>
//             ) : (
//               filtered.map((o) => {
//                 const checked = values.includes(o.value);
//                 return (
//                   <button
//                     type="button"
//                     key={o.value}
//                     onClick={() => toggle(o.value)}
//                     className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-yellow-50 ${
//                       checked ? "bg-yellow-50" : ""
//                     }`}
//                   >
//                     <input type="checkbox" readOnly checked={checked} className="h-4 w-4" />
//                     <span className="truncate">{o.label}</span>
//                   </button>
//                 );
//               })
//             )}
//           </div>

//           {/* footer actions */}
//           <div className="flex items-center justify-between px-3 py-2 border-t">
//             <button
//               type="button"
//               className="text-sm text-gray-600 hover:underline"
//               onClick={() => onChange && onChange([])}
//             >
//               Clear all
//             </button>
//             <button
//               type="button"
//               className="rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-gray-900 hover:bg-amber-300"
//               onClick={() => setOpen(false)}
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* chips */}
//       {values.length > 0 && (
//         <div className="mt-2 flex flex-wrap gap-2">
//           {values.map((v) => (
//             <span
//               key={v}
//               className="inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs bg-yellow-50"
//             >
//               <span className="truncate max-w-[12rem]">{labelByVal.get(v) || v}</span>
//               <button
//                 type="button"
//                 onClick={() => remove(v)}
//                 className="rounded-full hover:bg-yellow-100 p-0.5"
//                 aria-label="Remove"
//               >
//                 <svg width="12" height="12" viewBox="0 0 24 24">
//                   <path
//                     d="M18 6L6 18M6 6l12 12"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     strokeLinecap="round"
//                   />
//                 </svg>
//               </button>
//             </span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }


// // src/pages/admin/coupons/AddCoupon.jsx
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";

// /* ------------------------- helpers ------------------------- */
// const toLocalDTValue = (iso) => {
//   if (!iso) return "";
//   const d = new Date(iso);
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };
// const toISOFromLocal = (localVal) => (localVal ? new Date(localVal).toISOString() : null);
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// /* =========================================================== */
// /*                         Component                           */
// /* =========================================================== */
// export default function AddCoupon() {
//   const { id } = useParams(); // couponId when editing
//   const isEdit = Boolean(id);
//   const navigate = useNavigate();

//   const [events, setEvents] = useState([]);
//   const [eventsLoading, setEventsLoading] = useState(true);

//   const [saving, setSaving] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const fileInputRef = useRef(null);

//   const [formData, setFormData] = useState({
//     code: "",
//     description: "",
//     discountType: "percentage", // "percentage" | "fixed" | "bogo"
//     value: 0,
//     validFrom: "",
//     validTo: "",
//     imageUrl: "",
//     usageLimit: 0,
//     minPurchaseAmount: 0,
//     applicableEvents: [], // array of event IDs
//     isActive: true,
//     perUserLimit: 0,
//     isShow: true, // NEW: show/hide on app


//     // NEW
//     maxDiscountAmount: 0, // 0 = no cap
//     termsAndConditions: [],

//     // BOGO specific
//     buy: 1,
//     get: 1,
//     applicableCategory: "",
//   });

//   /* --------------------- fetch events list --------------------- */
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setEventsLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.events.getEvent, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined },
//         });
//         if (alive && Array.isArray(res?.events)) setEvents(res.events);
//       } catch (err) {
//         console.error("getAllEvents error:", err);
//         toast.error("Couldn’t load events.");
//       } finally {
//         if (alive) setEventsLoading(false);
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, []);

//   /* --------------------- fetch for editing --------------------- */
//   useEffect(() => {
//     if (!isEdit) return;
//     let alive = true;
//     (async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.coupon.getSingle}/${id}`, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined },
//         });

//         const d = res?.discount;
//         if (!alive || !d) return;

//         const eventIds = Array.isArray(d.applicableEvents)
//           ? d.applicableEvents.map((ev) => (typeof ev === "string" ? ev : ev?._id)).filter(Boolean)
//           : [];

//         setFormData({
//           code: d.code || "",
//           description: d.description || "",
//           discountType: d.discountType || "percentage",
//           value: Number(d.value ?? 0),
//           validFrom: toLocalDTValue(d.validFrom),
//           validTo: toLocalDTValue(d.validTo),
//           imageUrl: d.imageUrl || "",
//           usageLimit: Number(d.usageLimit ?? 0),
//           minPurchaseAmount: Number(d.minPurchaseAmount ?? 0),
//           perUserLimit: Number(d.perUserLimit ?? 0),
//           applicableEvents: eventIds,
//           isActive: Boolean(d.isActive),
//           isShow: d.isShow !== undefined ? Boolean(d.isShow) : true, // NEW

//           maxDiscountAmount: Number(d.maxDiscountAmount ?? 0),
//           termsAndConditions: Array.isArray(d.termsAndConditions)
//             ? d.termsAndConditions
//             : d.termsAndConditions
//               ? [String(d.termsAndConditions)]
//               : [],

//           buy: Number(d.buy ?? 1),
//           get: Number(d.get ?? 1),
//           applicableCategory: d.applicableCategory || "",
//         });
//         toast.info("Editing existing coupon.");
//       } catch (err) {
//         console.error("Error fetching coupon:", err);
//         toast.error("Failed to load coupon.");
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, [id, isEdit]);

//   /* ------------------------ derived state ----------------------- */
//   const isBOGO = formData.discountType === "bogo";
//   const valueMax = useMemo(() => (formData.discountType === "percentage" ? 100 : undefined), [
//     formData.discountType,
//   ]);

//   /* ----------------------- change handlers ---------------------- */
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     // number fields
//     const numberFields = new Set([
//       "value",
//       "usageLimit",
//       "minPurchaseAmount",
//       "perUserLimit",
//       "buy",
//       "get",
//       "maxDiscountAmount",
//     ]);
//     if (numberFields.has(name)) {
//       const num = value === "" ? "" : Number(value);
//       setFormData((p) => ({ ...p, [name]: num }));
//       return;
//     }

//     if (type === "checkbox") {
//       setFormData((p) => ({ ...p, [name]: checked }));
//       return;
//     }

//     setFormData((p) => ({ ...p, [name]: value }));
//   };

//   // Terms & Conditions
//   const addTerm = () =>
//     setFormData((p) => ({ ...p, termsAndConditions: [...(p.termsAndConditions || []), ""] }));

//   const updateTerm = (idx, val) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr[idx] = val;
//       return { ...p, termsAndConditions: arr };
//     });

//   const removeTerm = (idx) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr.splice(idx, 1);
//       return { ...p, termsAndConditions: arr };
//     });

//   /* ------------------------ image upload ------------------------ */
//   const onPickFile = () => fileInputRef.current?.click();

//   const handleImageUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (!ACCEPTED_IMG.includes(file.type)) {
//       toast.warn("Please upload JPG/PNG/WEBP image.");
//       return;
//     }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) {
//       toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
//       return;
//     }

//     try {
//       setUploading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const formDataObj = new FormData();
//       formDataObj.append("file", file);

//       const res = await post(API.events.fileUploader, formDataObj, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (res?.url) {
//         setFormData((prev) => ({ ...prev, imageUrl: res.url }));
//         toast.success("Image uploaded ✅");
//       } else {
//         toast.error("Upload failed. No URL returned.");
//       }
//     } catch (error) {
//       console.error("Image upload failed:", error);
//       toast.error("Image upload failed ❌");
//     } finally {
//       setUploading(false);
//     }
//   };

//   /* --------------------------- submit --------------------------- */
//   const validate = () => {
//     if (!formData.code.trim()) return toast.warn("Please enter a coupon code.");
//     if (!formData.discountType) return toast.warn("Select a discount type.");
//     if (!formData.validFrom || !formData.validTo)
//       return toast.warn("Choose a validity range.");
//     if (!isBOGO) {
//       if (formData.discountType === "percentage" && (formData.value < 0 || formData.value > 100))
//         return toast.warn("Percentage must be between 0 and 100.");
//       if (formData.discountType === "fixed" && Number(formData.value) < 0)
//         return toast.warn("Fixed amount cannot be negative.");
//     } else {
//       if (Number(formData.buy) <= 0 || Number(formData.get) <= 0)
//         return toast.warn("For BOGO, Buy and Get must be greater than 0.");
//       if (!String(formData.applicableCategory || "").trim())
//         return toast.warn("For BOGO, enter Applicable Category.");
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       setSaving(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//       const base = {
//         code: formData.code.trim(),
//         description: formData.description.trim(),
//         discountType: formData.discountType,
//         validFrom: toISOFromLocal(formData.validFrom),
//         validTo: toISOFromLocal(formData.validTo),
//         imageUrl: formData.imageUrl || "",
//         usageLimit: Number(formData.usageLimit || 0),
//         minPurchaseAmount: Number(formData.minPurchaseAmount || 0),
//         applicableEvents: Array.isArray(formData.applicableEvents) ? formData.applicableEvents : [],
//         isActive: !!formData.isActive,
//         isShow: !!formData.isShow,              // <-- send it!
//         perUserLimit: Number(formData.perUserLimit || 0),
//         maxDiscountAmount: Number(formData.maxDiscountAmount || 0),
//         termsAndConditions: (Array.isArray(formData.termsAndConditions) ? formData.termsAndConditions : [])
//           .map((s) => String(s).trim())
//           .filter(Boolean),
//       };

//       let payload = { ...base };
//       if (isBOGO) {
//         payload = {
//           ...base,
//           buy: Number(formData.buy || 0),
//           get: Number(formData.get || 0),
//           applicableCategory: (formData.applicableCategory || "").trim(),
//         };
//       } else {
//         payload = { ...base, value: Number(formData.value || 0) };
//       }

//       if (isEdit) {
//         await put(`${API.coupon.updateDiscount}/${id}`, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Coupon updated successfully ✅");
//       } else {
//         await post(API.coupon.creareDiscount, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Coupon created successfully ✅");
//       }

//       navigate("/admin/coupon");
//     } catch (err) {
//       console.error("Error saving coupon:", err);
//       toast.error("Failed to save coupon ❌");
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ----------------------------- UI ----------------------------- */
//   return (
//     <div className="max-w-4xl mx-auto p-6 space-y-6">
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h2 className="text-2xl font-extrabold text-slate-900">
//             {isEdit ? "Edit Coupon" : "Add New Coupon"}
//           </h2>
//           <p className="text-sm text-slate-600">
//             Configure discount type, validity, limits and applicable events.
//           </p>
//         </div>
//         <button
//           onClick={() => navigate(-1)}
//           className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//         >
//           ← Back
//         </button>
//       </div>

//       <form
//         onSubmit={handleSubmit}
//         className="rounded-2xl bg-white/90 backdrop-blur shadow-sm border p-6 space-y-6"
//       >
//         {/* Code & Description */}
//         <div className="grid gap-4 md:grid-cols-2">
//           <div>
//             <label className={AD.fieldLabel}>
//               Code <span className="text-rose-500">*</span>
//             </label>
//             <div className="mt-1 flex items-center gap-2">
//               <input
//                 type="text"
//                 name="code"
//                 value={formData.code}
//                 onChange={handleChange}
//                 required
//                 placeholder="FESTIVE50"
//                 className="w-full rounded-xl border px-4 py-2.5 focus:ring-2 focus:ring-amber-300"
//               />
//               <button
//                 type="button"
//                 onClick={() =>
//                   setFormData((p) => ({
//                     ...p,
//                     code: p.code || `SAVE${Math.floor(Math.random() * 900) + 100}`,
//                   }))
//                 }
//                 className="rounded-full border px-3 py-2 text-xs font-semibold hover:bg-slate-50"
//               >
//                 Generate
//               </button>
//             </div>
//           </div>

//           <div>
//             <label className={AD.fieldLabel}>Discount Type</label>
//             <div className="relative mt-1">
//               <select
//                 name="discountType"
//                 value={formData.discountType}
//                 onChange={handleChange}
//                 className="w-full appearance-none rounded-xl border px-4 py-2.5 pr-9"
//               >
//                 <option value="percentage">Percentage</option>
//                 <option value="fixed">Fixed Amount</option>
//                 <option value="bogo">BOGO</option>
//               </select>
//               <svg
//                 className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//                 width="16"
//                 height="16"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="1.8"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         <div>
//           <label className={AD.fieldLabel}>Description</label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             rows={3}
//             placeholder="Flat 50% off on festive season events"
//             className={cn("mt-1", AD.inputField)}
//           />
//         </div>

//         {/* Value OR BOGO fields */}
//         {!isBOGO ? (
//           <div className="grid gap-4 md:grid-cols-2">
//             <div>
//               <label className={AD.fieldLabel}>
//                 {formData.discountType === "percentage" ? "Value (%)" : "Value (₹)"}{" "}
//                 <span className="text-rose-500">*</span>
//               </label>
//               <input
//                 type="number"
//                 name="value"
//                 value={formData.value}
//                 onChange={handleChange}
//                 min={0}
//                 max={valueMax}
//                 step={formData.discountType === "percentage" ? "0.01" : "1"}
//                 required
//                 placeholder={formData.discountType === "percentage" ? "e.g. 50" : "e.g. 200"}
//                 className={cn("mt-1", AD.inputField)}
//               />
//               <p className="text-xs text-slate-500 mt-1">
//                 {formData.discountType === "percentage" ? "0–100 allowed" : "Fixed discount in ₹"}
//               </p>
//             </div>
//             <div>
//               <label className={AD.fieldLabel}>
//                 Maximum Discount Amount (₹)
//               </label>
//               <input
//                 type="number"
//                 name="maxDiscountAmount"
//                 value={formData.maxDiscountAmount}
//                 onChange={handleChange}
//                 min={0}
//                 step="0.01"
//                 placeholder="0 = No cap"
//                 className={cn("mt-1", AD.inputField)}
//               />
//               <p className="text-xs text-slate-500 mt-1">Put 0 to disable the cap.</p>
//             </div>
//           </div>
//         ) : (
//           <div className="grid gap-4 md:grid-cols-3">
//             <div>
//               <label className={AD.fieldLabel}>Buy (Qty)</label>
//               <input
//                 type="number"
//                 name="buy"
//                 value={formData.buy}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className={cn("mt-1", AD.inputField)}
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className={AD.fieldLabel}>Get (Qty)</label>
//               <input
//                 type="number"
//                 name="get"
//                 value={formData.get}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className={cn("mt-1", AD.inputField)}
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className={AD.fieldLabel}>Applicable Category</label>
//               <input
//                 type="text"
//                 name="applicableCategory"
//                 value={formData.applicableCategory}
//                 onChange={handleChange}
//                 placeholder="e.g. VVIP / Gold / GA"
//                 className={cn("mt-1", AD.inputField)}
//               />
//               <p className="text-xs text-slate-500 mt-1">Where BOGO applies.</p>
//             </div>
//           </div>
//         )}

//         {/* Validity */}
//         <div className="grid gap-4 md:grid-cols-2">
//           <div>
//             <label className={AD.fieldLabel}>
//               Valid From <span className="text-rose-500">*</span>
//             </label>
//             <input
//               type="datetime-local"
//               name="validFrom"
//               value={formData.validFrom}
//               onChange={handleChange}
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>
//               Valid To <span className="text-rose-500">*</span>
//             </label>
//             <input
//               type="datetime-local"
//               name="validTo"
//               value={formData.validTo}
//               onChange={handleChange}
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//         </div>

//         {/* Limits / Minimums + Image + Per User */}
//         <div className="grid gap-4 md:grid-cols-3">
//           <div>
//             <label className={AD.fieldLabel}>Usage Limit</label>
//             <input
//               type="number"
//               name="usageLimit"
//               value={formData.usageLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               placeholder="e.g. 100"
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>Min Purchase (₹)</label>
//             <input
//               type="number"
//               name="minPurchaseAmount"
//               value={formData.minPurchaseAmount}
//               onChange={handleChange}
//               min={0}
//               step="0.01"
//               placeholder="e.g. 500"
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>Per User Limit</label>
//             <input
//               type="number"
//               name="perUserLimit"
//               value={formData.perUserLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//         </div>

//         {/* Image */}
//         <div className="rounded-xl border px-4 py-4">
//           <div className="flex items-start gap-4">
//             <div className="min-w-[12rem]">
//               <div className="text-sm font-semibold text-slate-700">Promo Image</div>
//               <div className="text-xs text-slate-500">JPG/PNG/WEBP • &lt; {MAX_IMG_MB}MB</div>
//               <div className="mt-2 flex items-center gap-2">
//                 <button
//                   type="button"
//                   onClick={onPickFile}
//                   disabled={uploading}
//                   className="rounded-full bg-amber-500 text-slate-900 px-4 py-2 text-sm font-semibold hover:bg-amber-400 disabled:opacity-60"
//                 >
//                   {uploading ? "Uploading…" : "Upload"}
//                 </button>
//                 {formData.imageUrl && (
//                   <button
//                     type="button"
//                     onClick={() => setFormData((s) => ({ ...s, imageUrl: "" }))}
//                     className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//                   >
//                     Remove
//                   </button>
//                 )}
//               </div>
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept={ACCEPTED_IMG.join(",")}
//                 className="hidden"
//                 onChange={handleImageUpload}
//               />
//             </div>

//             {formData.imageUrl ? (
//               <img
//                 src={formData.imageUrl}
//                 alt="Promo preview"
//                 className="h-28 w-48 rounded-xl object-cover border"
//               />
//             ) : (
//               <div className="grow rounded-xl bg-slate-50 grid place-items-center text-slate-400 text-sm h-28">
//                 No image selected
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Terms & Conditions */}
//         <div>
//           <div className="flex items-center justify-between">
//             <label className={AD.fieldLabel}>
//               Terms &amp; Conditions
//             </label>
//             <button
//               type="button"
//               onClick={addTerm}
//               className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 hover:bg-amber-300"
//             >
//               + Add line
//             </button>
//           </div>

//           {formData.termsAndConditions?.length === 0 && (
//             <p className="text-xs text-slate-500 mt-1">
//               Add one or more T&amp;C lines. Each will be shown separately to users.
//             </p>
//           )}

//           <div className="mt-2 space-y-2">
//             {formData.termsAndConditions?.map((t, idx) => (
//               <div key={idx} className="flex items-start gap-2">
//                 <div className="pt-2 text-slate-400 text-sm">{idx + 1}.</div>
//                 <textarea
//                   value={t}
//                   onChange={(e) => updateTerm(idx, e.target.value)}
//                   rows={2}
//                   placeholder="Type a condition"
//                   className="flex-1 rounded-xl border px-3 py-2 text-sm focus:ring-2 focus:ring-amber-300"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => removeTerm(idx)}
//                   className="mt-2 rounded-full border px-2 py-1 text-sm hover:bg-slate-50"
//                   aria-label="Remove"
//                   title="Remove line"
//                 >
//                   ✕
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Applicable Events */}
//         <div>
//           <label className={AD.fieldLabel}>Applicable Events</label>
//           <MultiSelect
//             options={events.map((ev) => ({ label: ev.name, value: ev._id }))}
//             values={formData.applicableEvents}
//             onChange={(vals) => setFormData((p) => ({ ...p, applicableEvents: vals }))}
//             placeholder={eventsLoading ? "Loading events…" : "Select events"}
//             disabled={eventsLoading || events.length === 0}
//           />
//         </div>

//         {/* Active toggle */}
//         <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//           <div>
//             <div className="text-sm font-semibold text-slate-800">Active</div>
//             <div className="text-xs text-slate-500">
//               Disabled coupons will not be available to users.
//             </div>
//           </div>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               name="isActive"
//               checked={formData.isActive}
//               onChange={handleChange}
//               className="sr-only peer"
//             />
//             <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//               <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//             </div>
//           </label>
//         </div>

//         <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//           <div>
//             <div className="text-sm font-semibold text-slate-800">Show on app</div>
//             <div className="text-xs text-slate-500">
//               Turn off to hide this coupon from listings/search but keep it usable via code.
//             </div>
//           </div>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               name="isShow"
//               checked={formData.isShow}
//               onChange={handleChange}
//               className="sr-only peer"
//             />
//             <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//               <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//             </div>
//           </label>
//         </div>

//         {/* Actions */}
//         <div className="flex items-center justify-end gap-2">
//           <button
//             type="button"
//             onClick={() => navigate("/admin/coupon")}
//             className="rounded-full border px-5 py-2.5 text-sm font-semibold hover:bg-slate-50"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={saving}
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               saving && "opacity-60 cursor-wait"
//             )}
//           >
//             {saving ? (isEdit ? "Updating…" : "Saving…") : isEdit ? "Update Coupon" : "Save Coupon"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// /* ================= MultiSelect (refined) ================= */
// function MultiSelect({ options = [], values = [], onChange, placeholder = "Select…", disabled = false }) {
//   const [open, setOpen] = useState(false);
//   const [query, setQuery] = useState("");
//   const boxRef = useRef(null);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!boxRef.current?.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return options;
//     return options.filter((o) => o.label.toLowerCase().includes(q));
//   }, [options, query]);

//   const toggle = (val) => {
//     if (!onChange) return;
//     if (values.includes(val)) onChange(values.filter((v) => v !== val));
//     else onChange([...values, val]);
//   };

//   const remove = (val) => onChange && onChange(values.filter((v) => v !== val));

//   const labelByVal = useMemo(() => {
//     const m = new Map();
//     options.forEach((o) => m.set(o.value, o.label));
//     return m;
//   }, [options]);

//   const buttonText =
//     values.length === 0
//       ? placeholder
//       : values.length === 1
//         ? labelByVal.get(values[0]) || "1 selected"
//         : `${values.length} selected`;

//   return (
//     <div className="relative" ref={boxRef}>
//       <button
//         type="button"
//         disabled={disabled}
//         onClick={() => setOpen((o) => !o)}
//         className={cn(
//           "w-full border rounded-xl px-3 py-2 text-left flex items-center justify-between",
//           "focus:outline-none focus:ring-2 focus:ring-amber-300",
//           disabled && "bg-slate-50 cursor-not-allowed text-slate-400"
//         )}
//       >
//         <span className="truncate">{buttonText}</span>
//         <svg width="16" height="16" viewBox="0 0 24 24">
//           <polyline points="6 9 12 15 18 9" fill="none" stroke="currentColor" strokeWidth="2" />
//         </svg>
//       </button>

//       {open && !disabled && (
//         <div className="absolute z-50 mt-2 w-full rounded-xl border bg-white shadow-lg">
//           {/* search */}
//           <div className="p-2 border-b">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search events…"
//               className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-300"
//             />
//           </div>

//           {/* options */}
//           <div className="max-h-64 overflow-auto py-1">
//             {filtered.length === 0 ? (
//               <div className="px-3 py-2 text-sm text-slate-500">No results</div>
//             ) : (
//               filtered.map((o) => {
//                 const checked = values.includes(o.value);
//                 return (
//                   <button
//                     type="button"
//                     key={o.value}
//                     onClick={() => toggle(o.value)}
//                     className={cn(
//                       "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-amber-50",
//                       checked && "bg-amber-50"
//                     )}
//                   >
//                     <input type="checkbox" readOnly checked={checked} className="h-4 w-4" />
//                     <span className="truncate">{o.label}</span>
//                   </button>
//                 );
//               })
//             )}
//           </div>

//           {/* footer actions */}
//           <div className="flex items-center justify-between px-3 py-2 border-t">
//             <button
//               type="button"
//               className="text-sm text-slate-600 hover:underline"
//               onClick={() => onChange && onChange([])}
//             >
//               Clear all
//             </button>
//             <button
//               type="button"
//               className="rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 hover:bg-amber-300"
//               onClick={() => setOpen(false)}
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* chips */}
//       {values.length > 0 && (
//         <div className="mt-2 flex flex-wrap gap-2">
//           {values.map((v) => (
//             <span
//               key={v}
//               className="inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs bg-amber-50"
//             >
//               <span className="truncate max-w-[12rem]">{labelByVal.get(v) || v}</span>
//               <button
//                 type="button"
//                 onClick={() => remove(v)}
//                 className="rounded-full hover:bg-amber-100 p-0.5"
//                 aria-label="Remove"
//               >
//                 <svg width="12" height="12" viewBox="0 0 24 24">
//                   <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                 </svg>
//               </button>
//             </span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }



// src/pages/admin/coupons/AddCoupon.jsx
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";

// /* ------------------------- helpers ------------------------- */
// const toLocalDTValue = (iso) => {
//   if (!iso) return "";
//   const d = new Date(iso);
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };
// const toISOFromLocal = (localVal) => (localVal ? new Date(localVal).toISOString() : null);
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// /* =========================================================== */
// /*                         Component                           */
// /* =========================================================== */
// export default function AddCoupon() {
//   const { id } = useParams(); // couponId when editing
//   const isEdit = Boolean(id);
//   const navigate = useNavigate();

//   const [events, setEvents] = useState([]);
//   const [eventsLoading, setEventsLoading] = useState(true);

//   const [saving, setSaving] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const fileInputRef = useRef(null);

//   const [formData, setFormData] = useState({
//     code: "",
//     description: "",
//     discountType: "percentage", // "percentage" | "fixed" | "bogo"
//     value: 0,
//     validFrom: "",
//     validTo: "",
//     imageUrl: "",
//     usageLimit: 0,
//     minPurchaseAmount: 0,
//     applicableEvents: [], // array of event IDs
//     isActive: true,
//     perUserLimit: 0,
//     isShow: true, // NEW: show/hide on app

//     // NEW
//     maxDiscountAmount: 0, // 0 = no cap
//     termsAndConditions: [],

//     // BOGO specific
//     buy: 1,
//     get: 1,
//     applicableCategory: "",

//     // NEW: how many paid tickets % applies to (0 => all). default 1
//     discountOnQty: 1,
//   });

//   /* --------------------- fetch events list --------------------- */
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setEventsLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.events.getEvent, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined },
//         });
//         if (alive && Array.isArray(res?.events)) setEvents(res.events);
//       } catch (err) {
//         console.error("getAllEvents error:", err);
//         toast.error("Couldn’t load events.");
//       } finally {
//         if (alive) setEventsLoading(false);
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, []);

//   /* --------------------- fetch for editing --------------------- */
//   useEffect(() => {
//     if (!isEdit) return;
//     let alive = true;
//     (async () => {
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.coupon.getSingle}/${id}`, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined },
//         });

//         const d = res?.discount;
//         if (!alive || !d) return;

//         const eventIds = Array.isArray(d.applicableEvents)
//           ? d.applicableEvents.map((ev) => (typeof ev === "string" ? ev : ev?._id)).filter(Boolean)
//           : [];

//         setFormData({
//           code: d.code || "",
//           description: d.description || "",
//           discountType: d.discountType || "percentage",
//           value: Number(d.value ?? 0),
//           validFrom: toLocalDTValue(d.validFrom),
//           validTo: toLocalDTValue(d.validTo),
//           imageUrl: d.imageUrl || "",
//           usageLimit: Number(d.usageLimit ?? 0),
//           minPurchaseAmount: Number(d.minPurchaseAmount ?? 0),
//           perUserLimit: Number(d.perUserLimit ?? 0),
//           applicableEvents: eventIds,
//           isActive: Boolean(d.isActive),
//           isShow: d.isShow !== undefined ? Boolean(d.isShow) : true, // NEW

//           maxDiscountAmount: Number(d.maxDiscountAmount ?? 0),
//           termsAndConditions: Array.isArray(d.termsAndConditions)
//             ? d.termsAndConditions
//             : d.termsAndConditions
//               ? [String(d.termsAndConditions)]
//               : [],

//           buy: Number(d.buy ?? 1),
//           get: Number(d.get ?? 1),
//           applicableCategory: d.applicableCategory || "",

//           // read discountOnQty from server if present, else default to 1
//           discountOnQty: Number(d.discountOnQty ?? 1),
//         });
//         toast.info("Editing existing coupon.");
//       } catch (err) {
//         console.error("Error fetching coupon:", err);
//         toast.error("Failed to load coupon.");
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, [id, isEdit]);

//   /* ------------------------ derived state ----------------------- */
//   const isBOGO = formData.discountType === "bogo";
//   const valueMax = useMemo(() => (formData.discountType === "percentage" ? 100 : undefined), [
//     formData.discountType,
//   ]);

//   /* ----------------------- change handlers ---------------------- */
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     // number fields
//     const numberFields = new Set([
//       "value",
//       "usageLimit",
//       "minPurchaseAmount",
//       "perUserLimit",
//       "buy",
//       "get",
//       "maxDiscountAmount",
//       "discountOnQty", // allow editing later if you add UI
//     ]);
//     if (numberFields.has(name)) {
//       const num = value === "" ? "" : Number(value);
//       setFormData((p) => ({ ...p, [name]: num }));
//       return;
//     }

//     if (type === "checkbox") {
//       setFormData((p) => ({ ...p, [name]: checked }));
//       return;
//     }

//     setFormData((p) => ({ ...p, [name]: value }));
//   };

//   // Terms & Conditions
//   const addTerm = () =>
//     setFormData((p) => ({ ...p, termsAndConditions: [...(p.termsAndConditions || []), ""] }));

//   const updateTerm = (idx, val) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr[idx] = val;
//       return { ...p, termsAndConditions: arr };
//     });

//   const removeTerm = (idx) =>
//     setFormData((p) => {
//       const arr = [...(p.termsAndConditions || [])];
//       arr.splice(idx, 1);
//       return { ...p, termsAndConditions: arr };
//     });

//   /* ------------------------ image upload ------------------------ */
//   const onPickFile = () => fileInputRef.current?.click();

//   const handleImageUpload = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (!ACCEPTED_IMG.includes(file.type)) {
//       toast.warn("Please upload JPG/PNG/WEBP image.");
//       return;
//     }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) {
//       toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
//       return;
//     }

//     try {
//       setUploading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const formDataObj = new FormData();
//       formDataObj.append("file", file);

//       const res = await post(API.events.fileUploader, formDataObj, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (res?.url) {
//         setFormData((prev) => ({ ...prev, imageUrl: res.url }));
//         toast.success("Image uploaded ✅");
//       } else {
//         toast.error("Upload failed. No URL returned.");
//       }
//     } catch (error) {
//       console.error("Image upload failed:", error);
//       toast.error("Image upload failed ❌");
//     } finally {
//       setUploading(false);
//     }
//   };

//   /* --------------------------- submit --------------------------- */
//   const validate = () => {
//     if (!formData.code.trim()) return toast.warn("Please enter a coupon code.");
//     if (!formData.discountType) return toast.warn("Select a discount type.");
//     if (!formData.validFrom || !formData.validTo)
//       return toast.warn("Choose a validity range.");
//     if (!isBOGO) {
//       if (formData.discountType === "percentage" && (formData.value < 0 || formData.value > 100))
//         return toast.warn("Percentage must be between 0 and 100.");
//       if (formData.discountType === "fixed" && Number(formData.value) < 0)
//         return toast.warn("Fixed amount cannot be negative.");
//       // validate discountOnQty for percentage
//       if (formData.discountType === "percentage") {
//         const n = Number(formData.discountOnQty);
//         if (!Number.isFinite(n) || !Number.isInteger(n) || n < 0) {
//           return toast.warn("discountOnQty must be an integer >= 0 (0 = all).");
//         }
//       }
//     } else {
//       if (Number(formData.buy) <= 0 || Number(formData.get) <= 0)
//         return toast.warn("For BOGO, Buy and Get must be greater than 0.");
//       if (!String(formData.applicableCategory || "").trim())
//         return toast.warn("For BOGO, enter Applicable Category.");
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       setSaving(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

//       const base = {
//         code: formData.code.trim(),
//         description: formData.description.trim(),
//         discountType: formData.discountType,
//         validFrom: toISOFromLocal(formData.validFrom),
//         validTo: toISOFromLocal(formData.validTo),
//         imageUrl: formData.imageUrl || "",
//         usageLimit: Number(formData.usageLimit || 0),
//         minPurchaseAmount: Number(formData.minPurchaseAmount || 0),
//         applicableEvents: Array.isArray(formData.applicableEvents) ? formData.applicableEvents : [],
//         isActive: !!formData.isActive,
//         isShow: !!formData.isShow, // <-- send it!
//         perUserLimit: Number(formData.perUserLimit || 0),
//         maxDiscountAmount: Number(formData.maxDiscountAmount || 0),
//         termsAndConditions: (Array.isArray(formData.termsAndConditions) ? formData.termsAndConditions : [])
//           .map((s) => String(s).trim())
//           .filter(Boolean),
//       };

//       let payload = { ...base };
//       if (isBOGO) {
//         payload = {
//           ...base,
//           buy: Number(formData.buy || 0),
//           get: Number(formData.get || 0),
//           applicableCategory: (formData.applicableCategory || "").trim(),
//         };
//       } else {
//         payload = { ...base, value: Number(formData.value || 0) };

//         // include discountOnQty when percentage (default to 1)
//         if (formData.discountType === "percentage") {
//           payload.discountOnQty = Number(formData.discountOnQty || 1);
//         }
//       }

//       if (isEdit) {
//         await put(`${API.coupon.updateDiscount}/${id}`, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Coupon updated successfully ✅");
//       } else {
//         await post(API.coupon.creareDiscount, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Coupon created successfully ✅");
//       }

//       navigate("/admin/coupon");
//     } catch (err) {
//       console.error("Error saving coupon:", err);
//       toast.error("Failed to save coupon ❌");
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ----------------------------- UI ----------------------------- */
//   return (
//     <div className="max-w-4xl mx-auto p-6 space-y-6">
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h2 className="text-2xl font-extrabold text-slate-900">
//             {isEdit ? "Edit Coupon" : "Add New Coupon"}
//           </h2>
//           <p className="text-sm text-slate-600">
//             Configure discount type, validity, limits and applicable events.
//           </p>
//         </div>
//         <button
//           onClick={() => navigate(-1)}
//           className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//         >
//           ← Back
//         </button>
//       </div>

//       <form
//         onSubmit={handleSubmit}
//         className="rounded-2xl bg-white/90 backdrop-blur shadow-sm border p-6 space-y-6"
//       >
//         {/* Code & Description */}
//         <div className="grid gap-4 md:grid-cols-2">
//           <div>
//             <label className={AD.fieldLabel}>
//               Code <span className="text-rose-500">*</span>
//             </label>
//             <div className="mt-1 flex items-center gap-2">
//               <input
//                 type="text"
//                 name="code"
//                 value={formData.code}
//                 onChange={handleChange}
//                 required
//                 placeholder="FESTIVE50"
//                 className="w-full rounded-xl border px-4 py-2.5 focus:ring-2 focus:ring-amber-300"
//               />
//               <button
//                 type="button"
//                 onClick={() =>
//                   setFormData((p) => ({
//                     ...p,
//                     code: p.code || `SAVE${Math.floor(Math.random() * 900) + 100}`,
//                   }))
//                 }
//                 className="rounded-full border px-3 py-2 text-xs font-semibold hover:bg-slate-50"
//               >
//                 Generate
//               </button>
//             </div>
//           </div>

//           <div>
//             <label className={AD.fieldLabel}>Discount Type</label>
//             <div className="relative mt-1">
//               <select
//                 name="discountType"
//                 value={formData.discountType}
//                 onChange={handleChange}
//                 className="w-full appearance-none rounded-xl border px-4 py-2.5 pr-9"
//               >
//                 <option value="percentage">Percentage</option>
//                 <option value="fixed">Fixed Amount</option>
//                 <option value="bogo">BOGO</option>
//               </select>
//               <svg
//                 className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//                 width="16"
//                 height="16"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="1.8"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </div>
//           </div>
//         </div>

//         <div>
//           <label className={AD.fieldLabel}>Description</label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             rows={3}
//             placeholder="Flat 50% off on festive season events"
//             className={cn("mt-1", AD.inputField)}
//           />
//         </div>

//         {/* Value OR BOGO fields */}
//         {!isBOGO ? (
//           <>
//             <div className={AD.formGrid2}>
//               <div>
//                 <label className={AD.fieldLabel}>
//                   {formData.discountType === "percentage" ? "Value (%)" : "Value (₹)"}{" "}
//                   <span className="text-rose-500">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   name="value"
//                   value={formData.value}
//                   onChange={handleChange}
//                   min={0}
//                   max={valueMax}
//                   step={formData.discountType === "percentage" ? "0.01" : "1"}
//                   required
//                   placeholder={formData.discountType === "percentage" ? "e.g. 50" : "e.g. 200"}
//                   className={cn("mt-1", AD.inputField)}
//                 />
//                 <p className="text-xs text-slate-500 mt-1">
//                   {formData.discountType === "percentage" ? "0–100 allowed" : "Fixed discount in ₹"}
//                 </p>
//               </div>
//               <div>
//                 <label className={AD.fieldLabel}>
//                   Maximum Discount Amount (₹)
//                 </label>
//                 <input
//                   type="number"
//                   name="maxDiscountAmount"
//                   value={formData.maxDiscountAmount}
//                   onChange={handleChange}
//                   min={0}
//                   step="0.01"
//                   placeholder="0 = No cap"
//                   className={cn("mt-1", AD.inputField)}
//                 />
//                 <p className="text-xs text-slate-500 mt-1">Put 0 to disable the cap.</p>
//               </div>
//             </div>

//             {/* NEW: discountOnQty input */}
//             {formData.discountType === "percentage" && (
//               <div className="mt-4">
//                 <label className={AD.fieldLabel}>
//                   Apply discount on how many paid tickets?
//                 </label>
//                 <div className="mt-1 flex gap-2 items-center">
//                   <input
//                     type="number"
//                     name="discountOnQty"
//                     value={formData.discountOnQty}
//                     onChange={handleChange}
//                     min={0}
//                     step="1"
//                     className="w-40 rounded-xl border px-4 py-2.5 focus:ring-2 focus:ring-amber-300"
//                     placeholder="e.g. 1 (0 = all)"
//                   />
//                   <div className="text-xs text-slate-500">
//                     Enter <strong>0</strong> to apply percentage to <em>all paid tickets</em>. Otherwise enter the number of paid tickets to apply the percentage to (highest-priced tickets first).
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         ) : (
//           <div className="grid gap-4 md:grid-cols-3">
//             <div>
//               <label className={AD.fieldLabel}>Buy (Qty)</label>
//               <input
//                 type="number"
//                 name="buy"
//                 value={formData.buy}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className={cn("mt-1", AD.inputField)}
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className={AD.fieldLabel}>Get (Qty)</label>
//               <input
//                 type="number"
//                 name="get"
//                 value={formData.get}
//                 onChange={handleChange}
//                 min={1}
//                 step="1"
//                 className={cn("mt-1", AD.inputField)}
//                 placeholder="e.g. 1"
//               />
//             </div>
//             <div>
//               <label className={AD.fieldLabel}>Applicable Category</label>
//               <input
//                 type="text"
//                 name="applicableCategory"
//                 value={formData.applicableCategory}
//                 onChange={handleChange}
//                 placeholder="e.g. VVIP / Gold / GA"
//                 className={cn("mt-1", AD.inputField)}
//               />
//               <p className="text-xs text-slate-500 mt-1">Where BOGO applies.</p>
//             </div>
//           </div>
//         )}

//         {/* Validity */}
//         <div className="grid gap-4 md:grid-cols-2">
//           <div>
//             <label className={AD.fieldLabel}>
//               Valid From <span className="text-rose-500">*</span>
//             </label>
//             <input
//               type="datetime-local"
//               name="validFrom"
//               value={formData.validFrom}
//               onChange={handleChange}
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>
//               Valid To <span className="text-rose-500">*</span>
//             </label>
//             <input
//               type="datetime-local"
//               name="validTo"
//               value={formData.validTo}
//               onChange={handleChange}
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//         </div>

//         {/* Limits / Minimums + Image + Per User */}
//         <div className="grid gap-4 md:grid-cols-3">
//           <div>
//             <label className={AD.fieldLabel}>Usage Limit</label>
//             <input
//               type="number"
//               name="usageLimit"
//               value={formData.usageLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               placeholder="e.g. 100"
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>Min Purchase (₹)</label>
//             <input
//               type="number"
//               name="minPurchaseAmount"
//               value={formData.minPurchaseAmount}
//               onChange={handleChange}
//               min={0}
//               step="0.01"
//               placeholder="e.g. 500"
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//           <div>
//             <label className={AD.fieldLabel}>Per User Limit</label>
//             <input
//               type="number"
//               name="perUserLimit"
//               value={formData.perUserLimit}
//               onChange={handleChange}
//               min={0}
//               step="1"
//               required
//               className={cn("mt-1", AD.inputField)}
//             />
//           </div>
//         </div>

//         {/* Image */}
//         <div className="rounded-xl border px-4 py-4">
//           <div className="flex items-start gap-4">
//             <div className="min-w-[12rem]">
//               <div className="text-sm font-semibold text-slate-700">Promo Image</div>
//               <div className="text-xs text-slate-500">JPG/PNG/WEBP • &lt; {MAX_IMG_MB}MB</div>
//               <div className="mt-2 flex items-center gap-2">
//                 <button
//                   type="button"
//                   onClick={onPickFile}
//                   disabled={uploading}
//                   className="rounded-full bg-amber-500 text-slate-900 px-4 py-2 text-sm font-semibold hover:bg-amber-400 disabled:opacity-60"
//                 >
//                   {uploading ? "Uploading…" : "Upload"}
//                 </button>
//                 {formData.imageUrl && (
//                   <button
//                     type="button"
//                     onClick={() => setFormData((s) => ({ ...s, imageUrl: "" }))}
//                     className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//                   >
//                     Remove
//                   </button>
//                 )}
//               </div>
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept={ACCEPTED_IMG.join(",")}
//                 className="hidden"
//                 onChange={handleImageUpload}
//               />
//             </div>

//             {formData.imageUrl ? (
//               <img
//                 src={formData.imageUrl}
//                 alt="Promo preview"
//                 className="h-28 w-48 rounded-xl object-cover border"
//               />
//             ) : (
//               <div className="grow rounded-xl bg-slate-50 grid place-items-center text-slate-400 text-sm h-28">
//                 No image selected
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Terms & Conditions */}
//         <div>
//           <div className="flex items-center justify-between">
//             <label className={AD.fieldLabel}>
//               Terms &amp; Conditions
//             </label>
//             <button
//               type="button"
//               onClick={addTerm}
//               className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 hover:bg-amber-300"
//             >
//               + Add line
//             </button>
//           </div>

//           {formData.termsAndConditions?.length === 0 && (
//             <p className="text-xs text-slate-500 mt-1">
//               Add one or more T&amp;C lines. Each will be shown separately to users.
//             </p>
//           )}

//           <div className="mt-2 space-y-2">
//             {formData.termsAndConditions?.map((t, idx) => (
//               <div key={idx} className="flex items-start gap-2">
//                 <div className="pt-2 text-slate-400 text-sm">{idx + 1}.</div>
//                 <textarea
//                   value={t}
//                   onChange={(e) => updateTerm(idx, e.target.value)}
//                   rows={2}
//                   placeholder="Type a condition"
//                   className="flex-1 rounded-xl border px-3 py-2 text-sm focus:ring-2 focus:ring-amber-300"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => removeTerm(idx)}
//                   className="mt-2 rounded-full border px-2 py-1 text-sm hover:bg-slate-50"
//                   aria-label="Remove"
//                   title="Remove line"
//                 >
//                   ✕
//                 </button>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Applicable Events */}
//         <div>
//           <label className={AD.fieldLabel}>Applicable Events</label>
//           <MultiSelect
//             options={events.map((ev) => ({ label: ev.name, value: ev._id }))}
//             values={formData.applicableEvents}
//             onChange={(vals) => setFormData((p) => ({ ...p, applicableEvents: vals }))}
//             placeholder={eventsLoading ? "Loading events…" : "Select events"}
//             disabled={eventsLoading || events.length === 0}
//           />
//         </div>

//         {/* Active toggle */}
//         <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//           <div>
//             <div className="text-sm font-semibold text-slate-800">Active</div>
//             <div className="text-xs text-slate-500">
//               Disabled coupons will not be available to users.
//             </div>
//           </div>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               name="isActive"
//               checked={formData.isActive}
//               onChange={handleChange}
//               className="sr-only peer"
//             />
//             <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//               <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//             </div>
//           </label>
//         </div>

//         <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//           <div>
//             <div className="text-sm font-semibold text-slate-800">Show on app</div>
//             <div className="text-xs text-slate-500">
//               Turn off to hide this coupon from listings/search but keep it usable via code.
//             </div>
//           </div>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               name="isShow"
//               checked={formData.isShow}
//               onChange={handleChange}
//               className="sr-only peer"
//             />
//             <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//               <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//             </div>
//           </label>
//         </div>

//         {/* Actions */}
//         <div className="flex items-center justify-end gap-2">
//           <button
//             type="button"
//             onClick={() => navigate("/admin/coupon")}
//             className="rounded-full border px-5 py-2.5 text-sm font-semibold hover:bg-slate-50"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={saving}
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               saving && "opacity-60 cursor-wait"
//             )}
//           >
//             {saving ? (isEdit ? "Updating…" : "Saving…") : isEdit ? "Update Coupon" : "Save Coupon"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// /* ================= MultiSelect (refined) ================= */
// function MultiSelect({ options = [], values = [], onChange, placeholder = "Select…", disabled = false }) {
//   const [open, setOpen] = useState(false);
//   const [query, setQuery] = useState("");
//   const boxRef = useRef(null);

//   useEffect(() => {
//     const onDocClick = (e) => {
//       if (!boxRef.current?.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onDocClick);
//     return () => document.removeEventListener("mousedown", onDocClick);
//   }, []);

//   const filtered = useMemo(() => {
//     const q = query.trim().toLowerCase();
//     if (!q) return options;
//     return options.filter((o) => o.label.toLowerCase().includes(q));
//   }, [options, query]);

//   const toggle = (val) => {
//     if (!onChange) return;
//     if (values.includes(val)) onChange(values.filter((v) => v !== val));
//     else onChange([...values, val]);
//   };

//   const remove = (val) => onChange && onChange(values.filter((v) => v !== val));

//   const labelByVal = useMemo(() => {
//     const m = new Map();
//     options.forEach((o) => m.set(o.value, o.label));
//     return m;
//   }, [options]);

//   const buttonText =
//     values.length === 0
//       ? placeholder
//       : values.length === 1
//         ? labelByVal.get(values[0]) || "1 selected"
//         : `${values.length} selected`;

//   return (
//     <div className="relative" ref={boxRef}>
//       <button
//         type="button"
//         disabled={disabled}
//         onClick={() => setOpen((o) => !o)}
//         className={cn(
//           "w-full border rounded-xl px-3 py-2 text-left flex items-center justify-between",
//           "focus:outline-none focus:ring-2 focus:ring-amber-300",
//           disabled && "bg-slate-50 cursor-not-allowed text-slate-400"
//         )}
//       >
//         <span className="truncate">{buttonText}</span>
//         <svg width="16" height="16" viewBox="0 0 24 24">
//           <polyline points="6 9 12 15 18 9" fill="none" stroke="currentColor" strokeWidth="2" />
//         </svg>
//       </button>

//       {open && !disabled && (
//         <div className="absolute z-50 mt-2 w-full rounded-xl border bg-white shadow-lg">
//           {/* search */}
//           <div className="p-2 border-b">
//             <input
//               type="text"
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search events…"
//               className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-300"
//             />
//           </div>

//           {/* options */}
//           <div className="max-h-64 overflow-auto py-1">
//             {filtered.length === 0 ? (
//               <div className="px-3 py-2 text-sm text-slate-500">No results</div>
//             ) : (
//               filtered.map((o) => {
//                 const checked = values.includes(o.value);
//                 return (
//                   <button
//                     type="button"
//                     key={o.value}
//                     onClick={() => toggle(o.value)}
//                     className={cn(
//                       "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-amber-50",
//                       checked && "bg-amber-50"
//                     )}
//                   >
//                     <input type="checkbox" readOnly checked={checked} className="h-4 w-4" />
//                     <span className="truncate">{o.label}</span>
//                   </button>
//                 );
//               })
//             )}
//           </div>

//           {/* footer actions */}
//           <div className="flex items-center justify-between px-3 py-2 border-t">
//             <button
//               type="button"
//               className="text-sm text-slate-600 hover:underline"
//               onClick={() => onChange && onChange([])}
//             >
//               Clear all
//             </button>
//             <button
//               type="button"
//               className="rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 hover:bg-amber-300"
//               onClick={() => setOpen(false)}
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* chips */}
//       {values.length > 0 && (
//         <div className="mt-2 flex flex-wrap gap-2">
//           {values.map((v) => (
//             <span
//               key={v}
//               className="inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs bg-amber-50"
//             >
//               <span className="truncate max-w-[12rem]">{labelByVal.get(v) || v}</span>
//               <button
//                 type="button"
//                 onClick={() => remove(v)}
//                 className="rounded-full hover:bg-amber-100 p-0.5"
//                 aria-label="Remove"
//               >
//                 <svg width="12" height="12" viewBox="0 0 24 24">
//                   <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
//                 </svg>
//               </button>
//             </span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// src/pages/admin/coupons/AddCoupon.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { get, post, put } from "../../../lib/http";
import { API } from "../../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AD, focusAdminField } from "../../adminUi.js";

/* ------------------------- helpers ------------------------- */
const toLocalDTValue = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`;
};
const toISOFromLocal = (localVal) => (localVal ? new Date(localVal).toISOString() : null);
const cn = (...a) => a.filter(Boolean).join(" ");
const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
const MAX_IMG_MB = 5;

/* =========================================================== */
/*                         Component                           */
/* =========================================================== */
export default function AddCoupon() {
  const { id } = useParams(); // couponId when editing
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);

  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    code: "",
    description: "",
    discountType: "percentage", // "percentage" | "flat" | "bogo"
    value: 0,
    validFrom: "",
    validTo: "",
    imageUrl: "",
    usageLimit: 0,
    minPurchaseAmount: 0,
    applicableEvents: [], // array of event IDs
    isActive: true,
    perUserLimit: 0,
    isShow: true, // NEW: show/hide on app

    // NEW
    maxDiscountAmount: 0, // 0 = no cap
    termsAndConditions: [],

    // BOGO specific
    buy: 1,
    get: 1,
    applicableCategory: "",

    // NEW: how many paid tickets % applies to (0 => all). default 1
    discountOnQty: 1,
  });

  /* --------------------- fetch events list --------------------- */
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setEventsLoading(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(API.events.getEvent, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined },
        });
        if (alive && Array.isArray(res?.events)) setEvents(res.events);
      } catch (err) {
        console.error("getAllEvents error:", err);
        toast.error("Couldn’t load events.");
      } finally {
        if (alive) setEventsLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  /* --------------------- fetch for editing --------------------- */
  useEffect(() => {
    if (!isEdit) return;
    let alive = true;
    (async () => {
      try {
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(`${API.coupon.getSingle}/${id}`, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined },
        });

        const d = res?.discount;
        if (!alive || !d) return;

        const eventIds = Array.isArray(d.applicableEvents)
          ? d.applicableEvents.map((ev) => (typeof ev === "string" ? ev : ev?._id)).filter(Boolean)
          : [];

        setFormData({
          code: d.code || "",
          description: d.description || "",
          discountType:
            d.discountType === "fixed" ? "flat" : d.discountType || "percentage",
          value: Number(d.value ?? 0),
          validFrom: toLocalDTValue(d.validFrom),
          validTo: toLocalDTValue(d.validTo),
          imageUrl: d.imageUrl || "",
          usageLimit: Number(d.usageLimit ?? 0),
          minPurchaseAmount: Number(d.minPurchaseAmount ?? 0),
          perUserLimit: Number(d.perUserLimit ?? 0),
          applicableEvents: eventIds,
          isActive: Boolean(d.isActive),
          isShow: d.isShow !== undefined ? Boolean(d.isShow) : true, // NEW

          maxDiscountAmount: Number(d.maxDiscountAmount ?? 0),
          termsAndConditions: Array.isArray(d.termsAndConditions)
            ? d.termsAndConditions
            : d.termsAndConditions
              ? [String(d.termsAndConditions)]
              : [],

          buy: Number(d.buy ?? 1),
          get: Number(d.get ?? 1),
          applicableCategory: d.applicableCategory || "",

          // read discountOnQty from server if present, else default to 1
          discountOnQty: Number(d.discountOnQty ?? 1),
        });
        toast.info("Editing existing coupon.");
      } catch (err) {
        console.error("Error fetching coupon:", err);
        toast.error("Failed to load coupon.");
      }
    })();
    return () => {
      alive = false;
    };
  }, [id, isEdit]);

  /* ------------------------ derived state ----------------------- */
  const isBOGO = formData.discountType === "bogo";
  const valueMax = useMemo(() => (formData.discountType === "percentage" ? 100 : undefined), [
    formData.discountType,
  ]);

  /* ----------------------- change handlers ---------------------- */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // number fields
    const numberFields = new Set([
      "value",
      "usageLimit",
      "minPurchaseAmount",
      "perUserLimit",
      "buy",
      "get",
      "maxDiscountAmount",
      "discountOnQty", // allow editing later if you add UI
    ]);
    if (numberFields.has(name)) {
      const num = value === "" ? "" : Number(value);
      setFormData((p) => ({ ...p, [name]: num }));
      return;
    }

    if (type === "checkbox") {
      setFormData((p) => ({ ...p, [name]: checked }));
      return;
    }

    setFormData((p) => ({ ...p, [name]: value }));
  };

  // Terms & Conditions
  const addTerm = () =>
    setFormData((p) => ({ ...p, termsAndConditions: [...(p.termsAndConditions || []), ""] }));

  const updateTerm = (idx, val) =>
    setFormData((p) => {
      const arr = [...(p.termsAndConditions || [])];
      arr[idx] = val;
      return { ...p, termsAndConditions: arr };
    });

  const removeTerm = (idx) =>
    setFormData((p) => {
      const arr = [...(p.termsAndConditions || [])];
      arr.splice(idx, 1);
      return { ...p, termsAndConditions: arr };
    });

  /* ------------------------ image upload ------------------------ */
  const onPickFile = () => fileInputRef.current?.click();

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!ACCEPTED_IMG.includes(file.type)) {
      toast.warn("Please upload JPG/PNG/WEBP image.");
      return;
    }
    if (file.size > MAX_IMG_MB * 1024 * 1024) {
      toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
      return;
    }

    try {
      setUploading(true);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const formDataObj = new FormData();
      formDataObj.append("file", file);

      const res = await post(API.events.fileUploader, formDataObj, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.url) {
        setFormData((prev) => ({ ...prev, imageUrl: res.url }));
        toast.success("Image uploaded ✅");
      } else {
        toast.error("Upload failed. No URL returned.");
      }
    } catch (error) {
      console.error("Image upload failed:", error);
      toast.error("Image upload failed ❌");
    } finally {
      setUploading(false);
    }
  };

  /* --------------------------- submit --------------------------- */
  const validate = () => {
    const fail = (message, field) => {
      toast.warn(message);
      focusAdminField(field);
      return false;
    };

    if (!formData.code.trim()) return fail("Please enter a coupon code.", "code");
    if (!formData.discountType) return fail("Select a discount type.", "discountType");
    if (!formData.validFrom) return fail("Choose a validity start date.", "validFrom");
    if (!formData.validTo) return fail("Choose a validity end date.", "validTo");
    if (!isBOGO) {
      if (formData.discountType === "percentage" && (formData.value < 0 || formData.value > 100))
        return fail("Percentage must be between 0 and 100.", "value");
      if (formData.discountType === "flat" && Number(formData.value) < 0)
        return fail("Fixed amount cannot be negative.", "value");
      if (formData.discountType === "percentage") {
        const n = Number(formData.discountOnQty);
        if (!Number.isFinite(n) || !Number.isInteger(n) || n < 0) {
          return fail("Discount ticket count must be an integer ≥ 0 (0 = all).", "discountOnQty");
        }
      }
    } else {
      if (Number(formData.buy) <= 0) return fail("For BOGO, Buy quantity must be greater than 0.", "buy");
      if (Number(formData.get) <= 0) return fail("For BOGO, Get quantity must be greater than 0.", "get");
      if (!String(formData.applicableCategory || "").trim())
        return fail("For BOGO, enter applicable category.", "applicableCategory");
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setSaving(true);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;

      const base = {
        code: formData.code.trim(),
        description: formData.description.trim(),
        discountType: formData.discountType,
        validFrom: toISOFromLocal(formData.validFrom),
        validTo: toISOFromLocal(formData.validTo),
        imageUrl: formData.imageUrl || "",
        usageLimit: Number(formData.usageLimit || 0),
        minPurchaseAmount: Number(formData.minPurchaseAmount || 0),
        applicableEvents: Array.isArray(formData.applicableEvents) ? formData.applicableEvents : [],
        isActive: !!formData.isActive,
        isShow: !!formData.isShow, // <-- send it!
        perUserLimit: Number(formData.perUserLimit || 0),
        maxDiscountAmount: Number(formData.maxDiscountAmount || 0),
        termsAndConditions: (Array.isArray(formData.termsAndConditions) ? formData.termsAndConditions : [])
          .map((s) => String(s).trim())
          .filter(Boolean),
      };

      let payload = { ...base };
      if (isBOGO) {
        payload = {
          ...base,
          buy: Number(formData.buy || 0),
          get: Number(formData.get || 0),
          applicableCategory: (formData.applicableCategory || "").trim(),
        };
      } else {
        payload = { ...base, value: Number(formData.value || 0) };

        // ---------- SAFE: include discountOnQty when percentage ----------
        // allow admin to set 0 (means apply to ALL paid tickets).
        // only default to 1 when the field is explicitly empty/null/undefined.
        if (formData.discountType === "percentage") {
          const rawDiscountOnQty = formData.discountOnQty;
          if (rawDiscountOnQty === null || rawDiscountOnQty === undefined || rawDiscountOnQty === "") {
            payload.discountOnQty = 1;
          } else {
            const n = Number(rawDiscountOnQty);
            payload.discountOnQty = Number.isFinite(n) ? n : 1;
          }
        }
        // ----------------------------------------------------------------
      }

      if (isEdit) {
        await put(`${API.coupon.updateDiscount}/${id}`, payload, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
        });
        toast.success("Coupon updated successfully ✅");
      } else {
        await post(API.coupon.creareDiscount, payload, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
        });
        toast.success("Coupon created successfully ✅");
      }

      navigate("/admin/coupon");
    } catch (err) {
      console.error("Error saving coupon:", err);
      toast.error("Failed to save coupon ❌");
    } finally {
      setSaving(false);
    }
  };

  /* ----------------------------- UI ----------------------------- */
  return (
    <div className={AD.formWrap}>
      {/* Header */}
      <div className={AD.formHeader}>
        <div>
          <h1 className={AD.title}>{isEdit ? "Edit coupon" : "Add coupon"}</h1>
          <p className={AD.subtitle}>
            Configure discount type, validity, limits and applicable events.
          </p>
        </div>
        <button type="button" onClick={() => navigate(-1)} className={AD.btnSecondary}>
          ← Back
        </button>
      </div>

      <form onSubmit={handleSubmit} className={cn(AD.formSurface, "space-y-6")}>
        {/* Code & Description */}
        <div className={AD.formGrid2}>
          <div>
            <label className={AD.fieldLabel}>
              Code <span className="text-rose-500">*</span>
            </label>
            <div className="mt-1 flex min-w-0 items-center gap-2">
              <input
                type="text"
                name="code"
                data-admin-field="code"
                value={formData.code}
                onChange={handleChange}
                required
                placeholder="FESTIVE50"
                className={cn("min-w-0 flex-1", AD.inputField)}
              />
              <button
                type="button"
                onClick={() =>
                  setFormData((p) => ({
                    ...p,
                    code: p.code || `SAVE${Math.floor(Math.random() * 900) + 100}`,
                  }))
                }
                className={`${AD.btnSecondary} shrink-0 py-2 text-xs`}
              >
                Generate
              </button>
            </div>
          </div>

          <div>
            <label className={AD.fieldLabel}>Discount Type</label>
            <div className="relative mt-1">
              <select
                name="discountType"
                data-admin-field="discountType"
                value={formData.discountType}
                onChange={handleChange}
                className={AD.select}
              >
                <option value="percentage">Percentage</option>
                <option value="flat">Fixed Amount</option>
                <option value="bogo">BOGO</option>
              </select>
              <svg
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
          </div>
        </div>

        <div>
          <label className={AD.fieldLabel}>Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            placeholder="Flat 50% off on festive season events"
            className={cn("mt-1", AD.textareaField)}
          />
        </div>

        {/* Value OR BOGO fields */}
        {!isBOGO ? (
          <>
            <div className={AD.formGrid2}>
              <div>
                <label className={AD.fieldLabel}>
                  {formData.discountType === "percentage" ? "Value (%)" : "Value (₹)"}{" "}
                  <span className="text-rose-500">*</span>
                </label>
                <input
                  type="number"
                  name="value"
                  data-admin-field="value"
                  value={formData.value}
                  onChange={handleChange}
                  min={0}
                  max={valueMax}
                  step={formData.discountType === "percentage" ? "0.01" : "1"}
                  required
                  placeholder={formData.discountType === "percentage" ? "e.g. 50" : "e.g. 200"}
                  className={cn("mt-1", AD.inputField)}
                />
                <p className={AD.fieldHint}>
                  {formData.discountType === "percentage" ? "0–100 allowed" : "Fixed discount in ₹"}
                </p>
              </div>
              <div>
                <label className={AD.fieldLabel}>
                  Maximum Discount Amount (₹)
                </label>
                <input
                  type="number"
                  name="maxDiscountAmount"
                  data-admin-field="maxDiscountAmount"
                  value={formData.maxDiscountAmount}
                  onChange={handleChange}
                  min={0}
                  step="0.01"
                  placeholder="0 = No cap"
                  className={cn("mt-1", AD.inputField)}
                />
                <p className={AD.fieldHint}>Put 0 to disable the cap.</p>
              </div>
            </div>

            {/* NEW: discountOnQty input */}
            {formData.discountType === "percentage" && (
              <div className="mt-4">
                <label className={AD.fieldLabel}>
                  Apply discount on how many paid tickets?
                </label>
                <div className="mt-1 flex flex-col gap-2 sm:flex-row sm:items-center">
                  <input
                    type="number"
                    name="discountOnQty"
                    data-admin-field="discountOnQty"
                    value={formData.discountOnQty}
                    onChange={handleChange}
                    min={0}
                    step="1"
                    className={cn("w-full sm:w-40 sm:shrink-0", AD.inputField)}
                    placeholder="e.g. 1 (0 = all)"
                  />
                  <div className={cn(AD.fieldHint, "sm:min-w-0 sm:flex-1")}>
                    Enter <strong>0</strong> to apply percentage to <em>all paid tickets</em>. Otherwise enter the number of paid tickets to apply the percentage to (highest-priced tickets first).
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className={cn(AD.formGrid3, "md:grid-cols-3")}>
            <div>
              <label className={AD.fieldLabel}>Buy (Qty)</label>
              <input
                type="number"
                name="buy"
                data-admin-field="buy"
                value={formData.buy}
                onChange={handleChange}
                min={1}
                step="1"
                className={cn("mt-1", AD.inputField)}
                placeholder="e.g. 1"
              />
            </div>
            <div>
              <label className={AD.fieldLabel}>Get (Qty)</label>
              <input
                type="number"
                name="get"
                data-admin-field="get"
                value={formData.get}
                onChange={handleChange}
                min={1}
                step="1"
                className={cn("mt-1", AD.inputField)}
                placeholder="e.g. 1"
              />
            </div>
            <div>
              <label className={AD.fieldLabel}>Applicable Category</label>
              <input
                type="text"
                name="applicableCategory"
                data-admin-field="applicableCategory"
                value={formData.applicableCategory}
                onChange={handleChange}
                placeholder="e.g. VVIP / Gold / GA"
                className={cn("mt-1", AD.inputField)}
              />
              <p className={AD.fieldHint}>Where BOGO applies.</p>
            </div>
          </div>
        )}

        {/* Validity */}
        <div className={AD.formGrid2}>
          <div>
            <label className={AD.fieldLabel}>
              Valid From <span className="text-rose-500">*</span>
            </label>
            <input
              type="datetime-local"
              name="validFrom"
              data-admin-field="validFrom"
              value={formData.validFrom}
              onChange={handleChange}
              required
              className={cn("mt-1", AD.inputField)}
            />
          </div>
          <div>
            <label className={AD.fieldLabel}>
              Valid To <span className="text-rose-500">*</span>
            </label>
            <input
              type="datetime-local"
              name="validTo"
              data-admin-field="validTo"
              value={formData.validTo}
              onChange={handleChange}
              required
              className={cn("mt-1", AD.inputField)}
            />
          </div>
        </div>

        {/* Limits / Minimums + Image + Per User */}
        <div className={cn(AD.formGrid3, "lg:grid-cols-3")}>
          <div>
            <label className={AD.fieldLabel}>Usage Limit</label>
            <input
              type="number"
              name="usageLimit"
              value={formData.usageLimit}
              onChange={handleChange}
              min={0}
              step="1"
              placeholder="e.g. 100"
              className={cn("mt-1", AD.inputField)}
            />
          </div>
          <div>
            <label className={AD.fieldLabel}>Min Purchase (₹)</label>
            <input
              type="number"
              name="minPurchaseAmount"
              value={formData.minPurchaseAmount}
              onChange={handleChange}
              min={0}
              step="0.01"
              placeholder="e.g. 500"
              className={cn("mt-1", AD.inputField)}
            />
          </div>
          <div>
            <label className={AD.fieldLabel}>Per User Limit</label>
            <input
              type="number"
              name="perUserLimit"
              value={formData.perUserLimit}
              onChange={handleChange}
              min={0}
              step="1"
              required
              className={cn("mt-1", AD.inputField)}
            />
          </div>
        </div>

        {/* Image */}
        <div className={cn(AD.toggleRow, "flex-wrap items-start")}>
          <div className="flex items-start gap-4">
            <div className="min-w-0 sm:min-w-[12rem]">
              <div className={AD.fieldLabel}>Promo image</div>
              <div className={AD.fieldHint}>JPG/PNG/WEBP • Max {MAX_IMG_MB} MB</div>
              <div className="mt-2 flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={onPickFile}
                  disabled={uploading}
                  className={`${AD.btnPrimary} py-2 text-sm disabled:opacity-60`}
                >
                  {uploading ? "Uploading…" : "Upload"}
                </button>
                {formData.imageUrl && (
                  <button
                    type="button"
                    onClick={() => setFormData((s) => ({ ...s, imageUrl: "" }))}
                    className={AD.btnSecondary}
                  >
                    Remove
                  </button>
                )}
              </div>
              <input
                ref={fileInputRef}
                type="file"
                accept={ACCEPTED_IMG.join(",")}
                className="hidden"
                onChange={handleImageUpload}
              />
            </div>

            {formData.imageUrl ? (
              <img
                src={formData.imageUrl}
                alt="Promo preview"
                className="h-28 w-48 rounded-xl object-cover border"
              />
            ) : (
              <div className="grow rounded-xl bg-slate-50 grid place-items-center text-slate-400 text-sm h-28">
                No image selected
              </div>
            )}
          </div>
        </div>

        {/* Terms & Conditions */}
        <div>
          <div className="flex items-center justify-between">
            <label className={AD.fieldLabel}>
              Terms &amp; Conditions
            </label>
            <button type="button" onClick={addTerm} className={`${AD.btnPrimary} py-2 text-xs`}>
              + Add line
            </button>
          </div>

          {formData.termsAndConditions?.length === 0 && (
            <p className={AD.fieldHint}>
              Add one or more T&amp;C lines. Each will be shown separately to users.
            </p>
          )}

          <div className="mt-2 space-y-2">
            {formData.termsAndConditions?.map((t, idx) => (
              <div key={idx} className="flex items-start gap-2">
                <div className="pt-2 text-slate-400 text-sm">{idx + 1}.</div>
                <textarea
                  value={t}
                  onChange={(e) => updateTerm(idx, e.target.value)}
                  rows={2}
                  placeholder="Type a condition"
                  className={cn("min-w-0 flex-1", AD.textareaField, "min-h-0")}
                />
                <button
                  type="button"
                  onClick={() => removeTerm(idx)}
                  className={`${AD.btnGhost} mt-2 shrink-0 border border-slate-200 px-2 py-1 text-sm dark:border-gray-700`}
                  aria-label="Remove"
                  title="Remove line"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Applicable Events */}
        <div>
          <label className={AD.fieldLabel}>Applicable Events</label>
          <MultiSelect
            options={events.map((ev) => ({ label: ev.name, value: ev._id }))}
            values={formData.applicableEvents}
            onChange={(vals) => setFormData((p) => ({ ...p, applicableEvents: vals }))}
            placeholder={eventsLoading ? "Loading events…" : "Select events"}
            disabled={eventsLoading || events.length === 0}
          />
        </div>

        {/* Active toggle */}
        <div className={AD.toggleRow}>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">Active</div>
            <div className={AD.fieldHint}>
              Disabled coupons will not be available to users.
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              name="isActive"
              checked={formData.isActive}
              onChange={handleChange}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
              <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
            </div>
          </label>
        </div>

        <div className={AD.toggleRow}>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">Show on app</div>
            <div className={AD.fieldHint}>
              Turn off to hide this coupon from listings/search but keep it usable via code.
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              name="isShow"
              checked={formData.isShow}
              onChange={handleChange}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
              <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
            </div>
          </label>
        </div>

        {/* Actions */}
        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-slate-100 pt-4 dark:border-gray-800">
          <button type="button" onClick={() => navigate("/admin/coupon")} className={AD.btnSecondary}>
            Cancel
          </button>
          <button type="submit" disabled={saving} className={cn(AD.btnPrimary, saving && "cursor-wait opacity-60")}>
            {saving ? (isEdit ? "Updating…" : "Saving…") : isEdit ? "Update coupon" : "Save coupon"}
          </button>
        </div>
      </form>
    </div>
  );
}

/* ================= MultiSelect (refined) ================= */
function MultiSelect({ options = [], values = [], onChange, placeholder = "Select…", disabled = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const boxRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!boxRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter((o) => o.label.toLowerCase().includes(q));
  }, [options, query]);

  const toggle = (val) => {
    if (!onChange) return;
    if (values.includes(val)) onChange(values.filter((v) => v !== val));
    else onChange([...values, val]);
  };

  const remove = (val) => onChange && onChange(values.filter((v) => v !== val));

  const labelByVal = useMemo(() => {
    const m = new Map();
    options.forEach((o) => m.set(o.value, o.label));
    return m;
  }, [options]);

  const buttonText =
    values.length === 0
      ? placeholder
      : values.length === 1
        ? labelByVal.get(values[0]) || "1 selected"
        : `${values.length} selected`;

  return (
    <div className="relative" ref={boxRef}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        className={cn(
          AD.select,
          "flex items-center justify-between py-2.5 text-left font-normal",
          disabled && "cursor-not-allowed bg-slate-50 text-slate-400"
        )}
      >
        <span className="truncate">{buttonText}</span>
        <svg width="16" height="16" viewBox="0 0 24 24">
          <polyline points="6 9 12 15 18 9" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      {open && !disabled && (
        <div className="absolute z-50 mt-2 w-full rounded-xl border bg-white shadow-lg">
          {/* search */}
          <div className="p-2 border-b">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search events…"
              className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-300"
            />
          </div>

          {/* options */}
          <div className="max-h-64 overflow-auto py-1">
            {filtered.length === 0 ? (
              <div className="px-3 py-2 text-sm text-slate-500">No results</div>
            ) : (
              filtered.map((o) => {
                const checked = values.includes(o.value);
                return (
                  <button
                    type="button"
                    key={o.value}
                    onClick={() => toggle(o.value)}
                    className={cn(
                      "w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-amber-50",
                      checked && "bg-amber-50"
                    )}
                  >
                    <input type="checkbox" readOnly checked={checked} className="h-4 w-4" />
                    <span className="truncate">{o.label}</span>
                  </button>
                );
              })
            )}
          </div>

          {/* footer actions */}
          <div className="flex items-center justify-between px-3 py-2 border-t">
            <button
              type="button"
              className="text-sm text-slate-600 hover:underline"
              onClick={() => onChange && onChange([])}
            >
              Clear all
            </button>
            <button
              type="button"
              className="rounded-full bg-amber-400 px-3 py-1.5 text-sm font-semibold text-slate-900 hover:bg-amber-300"
              onClick={() => setOpen(false)}
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* chips */}
      {values.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {values.map((v) => (
            <span
              key={v}
              className="inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs bg-amber-50"
            >
              <span className="truncate max-w-[12rem]">{labelByVal.get(v) || v}</span>
              <button
                type="button"
                onClick={() => remove(v)}
                className="rounded-full hover:bg-amber-100 p-0.5"
                aria-label="Remove"
              >
                <svg width="12" height="12" viewBox="0 0 24 24">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
